import { Upload } from 'antd';
import styled from 'styled-components';

export const CustomUpload = styled(Upload.Dragger)`
  .ant-upload-list-item-actions .ant-btn-icon-only {
    display: contents;
  }

  font-family: 'inter-regular', sans-serif;
  color: var(--FORM-LABEL-default);

  .ant-upload-hint {
    color: var(--FORM-LABEL-default) !important;
  }

  .ant-upload-list-item-name {
    text-decoration: underline;
    text-decoration-thickness: 0.5px !important;
    text-decoration-skip-ink: none;
    text-underline-offset: 3px;
  }
`;
